import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { Link, Navigate } from "react-router-dom";
import { encryptAES } from '../../utils/Encryption';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { CommonSuccessMessages } from '../../utils/Messages';
import { createRef } from 'react';

export default class JobList extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.dt = createRef();
        this.state = {
            jobList: [],
            isLoading: false,
            globalFilter: '',
            dateRange: null,
            filterDetails: {
                start: 0,
                length: -1,
                search: '',
                roleId: '',
                sortField: '',
                sortOrder: 'asc',
            }
        };
        this.exportCSV = this.exportCSV.bind(this);
        this.exportPdf = this.exportPdf.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
        this.saveAsExcelFile = this.saveAsExcelFile.bind(this);
    }

    componentDidMount() {
        this.getJobList();
    }

    getJobList = () => {
        let filterDetials = this.state.filterDetails;
        this.setState({ isLoading: true })
        let request = [filterDetials.start, filterDetials.length, filterDetials.search, filterDetials.roleId, filterDetials.sortField, filterDetials.sortOrder];
        this.adminServices.getJobList(request).then((response) => {
            if (response && response.data && response !== null) {
                let res = response.data;
                this.setState({ jobList: res });
                this.setState({ isLoading: false })
            }
        });
    }

    actionBodyTemplate = (rowData) => {
        return (
            <div className="flex gap-2 justify-center">
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handleEdit(rowData)}
                    tooltip="Edit"
                    tooltipOptions={{ position: 'top' }}
                />
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handleDelete(rowData)}
                    tooltip="Delete"
                    tooltipOptions={{ position: 'top' }}
                />
            </div>
        );
    };


    handleEdit = (rowData) => {
        if (rowData.jobid && rowData.jobid > 0) {
            this.setState({ route: '/job-details?=' + rowData.jobid });
        }
    };

    handleDelete = (rowData) => {
        if (rowData.jobid && rowData.jobid > 0) {
            this.swalServices.Confirm(
                "",
                ``,
                CommonSuccessMessages.Yes_Text,
                CommonSuccessMessages.No_Text,
                `Are you sure you want to delete ?`
            ).then((response) => {
                if (response === true) {
                    this.adminServices.deleteJob(rowData.jobid).then((response) => {
                        if (response.success === 1) {
                            this.getJobList();
                            this.swalServices.Success(response.msg)
                        } else {
                            this.swalServices.Error(response.msg)
                        }
                        this.setState({ isLoading: false });
                    });
                }
            })
        }
    };

    filterByDateRange = (createddate) => {
        const { dateRange } = this.state;

        if (!dateRange || !dateRange[0] || !dateRange[1]) return true;

        const created = new Date(createddate);
        const start = new Date(dateRange[0]);
        const end = new Date(dateRange[1]);

        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);

        return created >= start && created <= end;
    };

    exportCSV(selectionOnly) {
        if (this.dt.current) {
            this.dt.current.exportCSV({ selectionOnly });
        }
    }

    getExportColumns() {
        return this.state.jobList.map((col) => ({ title: 'ABC', dataKey: 'XYZ' }));
    }

    exportPdf() {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                const exportColumns = this.getExportColumns();
                doc.autoTable(exportColumns, this.state.jobList);
                doc.save('Job List.pdf');
            });
        });
    }

    saveAsExcelFile(buffer, fileName) {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], { type: EXCEL_TYPE });

                module.default.saveAs(data, "Job List" + EXCEL_EXTENSION);
            }
        });
    }

    exportExcel() {
        import('xlsx').then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(this.state.jobList);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });

            this.saveAsExcelFile(excelBuffer, 'jobList');
        });
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }

        const filteredData = this.state.jobList.filter((row) =>
            this.filterByDateRange(row.createddate)
        );

        const paginatorRight = (
            <div className="flex gap-2">
                <Button label="Export CSV" icon="pi pi-file" className="export-btn" onClick={() => this.exportCSV(false)} />
                <Button label="Export PDF" icon="pi pi-file-pdf" className="export-btn" onClick={this.exportPdf} />
                <Button label="Export Excel" icon="pi pi-file-excel" className="export-btn" onClick={this.exportExcel} />
            </div>
        );

        return (
            <div className='job-lists'
                style={{ height: "calc((100dvh / 0.85) - 60.8px)" }}
            >
                <div className='job-lists-inner h-full p-[30px]'>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>Job list</h1>
                        <Link to="/job-details">
                            <button className='flex items-center gap-[5px] py-[5px] px-[10px] text-[14px] font-medium rounded-[5px] text-[#FFFFFF] bg-[#0077B6] hover:bg-[#3b82f6] border-0'><FontAwesomeIcon className='w-5 h-5' icon={faBriefcase} />Add job</button>
                        </Link>
                    </div>
                    <div className='job-table p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                        <div className='table-inner grid grid-cols-3 gap-5 items-end'>
                            <div className="input-grp !mb-0">
                                <label>
                                    Search
                                </label>
                                <InputText
                                    type="search"
                                    value={this.state.globalFilter}
                                    onChange={(e) => this.setState({ globalFilter: e.target.value })}
                                    placeholder="Search across all columns..."
                                    style={{ height: "42px" }}
                                />
                            </div>
                            {/* <div className="input-grp !mb-0">
                                <label>
                                    Filter by Date Range
                                </label>
                                <Calendar
                                    value={this.state.dateRange}
                                    onChange={(e) => this.setState({ dateRange: e.value })}
                                    selectionMode="range"
                                    placeholder="Select date range"
                                    dateFormat="yy-mm-dd"
                                    readOnlyInput
                                    numberOfMonths={2}
                                />
                            </div>
                            <Button
                                label="Reset filters"
                                className='w-fit h-fit'
                                onClick={() => this.setState({ globalFilter: '', dateRange: null })}
                            /> */}
                        </div>
                        <div className='sub-table rounded-xl shadow-sm overflow-hidden border border-gray-200 bg-white mt-[30px]'>
                            <DataTable
                                value={filteredData}
                                // paginator
                                // rows={50}
                                responsiveLayout="scroll"
                                scrollable
                                scrollHeight="calc((100dvh / 0.85) - 300px)"
                                className="min-w-full"
                                globalFilter={this.state.globalFilter}
                                emptyMessage="No data found"
                                loading={this.state.isLoading}
                                loadingIcon={
                                    <div className="flex justify-center items-center w-full py-4">
                                        <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                    </div>
                                }
                            // paginator
                            // lazy
                            // paginatorRight={paginatorRight}
                            // ref={this.dt}
                            >
                                <Column
                                    field="jobid"
                                    body={(rowData, options) => options.rowIndex + 1}
                                    header="Sr No"
                                    filterPlaceholder="Search by ID"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="jobname"
                                    header="Job name"
                                    sortable
                                    filterPlaceholder="Search by job name"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="associatedJobtypes"
                                    header="Job type"
                                    sortable
                                    filterPlaceholder="Search by job type"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="associatedLocations"
                                    header="Job location"
                                    sortable
                                    filterPlaceholder="Search by location"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="createddate"
                                    header="Created Date"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    field="createdby"
                                    header="Created By"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    field="modifieddate"
                                    header="Updated Date"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    field="modifiedby"
                                    header="Updated By"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    header="Actions"
                                    body={this.actionBodyTemplate}
                                    style={{ textAlign: 'center', width: '10rem' }}
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}